var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVyhodnotit(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3485_3020)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.125 4.375H11.875C12.2188 4.375 12.5 4.65625 12.5 5C12.5 5.34375 12.2188 5.625 11.875 5.625H3.125C2.78125 5.625 2.5 5.34375 2.5 5C2.5 4.65625 2.78125 4.375 3.125 4.375Z",
    fill: "#0B0C0C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.125 8.125H11.875C12.2188 8.125 12.5 7.84375 12.5 7.5C12.5 7.15625 12.2188 6.875 11.875 6.875H3.125C2.78125 6.875 2.5 7.15625 2.5 7.5C2.5 7.84375 2.78125 8.125 3.125 8.125Z",
    fill: "#0B0C0C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.125 10.625H6.25C6.59375 10.625 6.875 10.3438 6.875 10C6.875 9.65625 6.59375 9.375 6.25 9.375H3.125C2.78125 9.375 2.5 9.65625 2.5 10C2.5 10.3438 2.78125 10.625 3.125 10.625Z",
    fill: "#0B0C0C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.125 13.125H6.25C6.59375 13.125 6.875 12.8438 6.875 12.5C6.875 12.1562 6.59375 11.875 6.25 11.875H3.125C2.78125 11.875 2.5 12.1562 2.5 12.5C2.5 12.8438 2.78125 13.125 3.125 13.125Z",
    fill: "#0B0C0C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.63123 11.3561L9.18748 10.9123C8.94373 10.6686 8.54998 10.6686 8.30623 10.9123C8.06248 11.1561 8.06248 11.5498 8.30623 11.7936L9.19373 12.6811C9.43748 12.9248 9.83123 12.9248 10.075 12.6811L12.0562 10.6998C12.3 10.4561 12.3 10.0623 12.0562 9.81855C11.8125 9.5748 11.4187 9.5748 11.175 9.81855L9.63123 11.3561Z",
    fill: "#0B0C0C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.5 2.5C2.5 2.84375 2.78125 3.125 3.125 3.125H11.875C12.2188 3.125 12.5 2.84375 12.5 2.5C12.5 2.15625 12.2188 1.875 11.875 1.875H3.125C2.78125 1.875 2.5 2.15625 2.5 2.5Z",
    fill: "#0B0C0C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3485_3020"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVyhodnotit);
export default __webpack_public_path__ + "static/media/vyhodnotit.e7699774efbb055ffff8e32ea878e218.svg";
export { ForwardRef as ReactComponent };